import React, { useEffect } from "react";

import "../all css/BlogView.css";

import "../all css/BlogDetails.css";
import { useLocation } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/footer";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";
const writeImage = require("../../assets/writes_ideas_svg.svg");
const blog_poster = require("../../assets/blogs/blog_poster.jpg");

export default function BlogView() {
  const points = [
    { value: 1 },
    { value: 1 },
    { value: 1 },
    { value: 1 },
    { value: 1 },
    { value: 1 },
  ];

  const { state } = useLocation();

  useEffect(() => {
    // console.log(state, "state");
  }, [state]);

  return (
    <>
      <div className="nav_container">
        <Navbar fromPage="newsdetails" />
      </div>
      <div className="bg_img_blog">
        <section className="main_blog_view_container">
          <div className="blog_view_section_under_contianer1">
            <img
              src={state.newsCoverImg}
              alt="writeImage"
              className="blog_image"
            />
            <p className="blog_view_date_text">{state.dateNews}</p>
            <p className="blog_view_title_text">{state.newsTitle}</p>
            <hr className="blog_view_line" />
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {points.map(() => {
                return <div className="blog_points" key={Math.random()} />;
              })}
            </div>

            <div
              className="blog_view_first_para"
              dangerouslySetInnerHTML={{
                __html: state.longDescriptionNews,
              }}
            ></div>
          </div>
        </section>
      </div>

      <InterestedSectionMain />

      <Footer />
    </>
  );
}
